import { Component, OnInit, ViewChild, OnDestroy } from '@angular/core';
import { GlobalSettings } from '../../global.settings';
import { CommonService } from '../../common.service';
import Utils from '../../utils';
import { SortListComponent } from '../../common/sort-list/sort-list.component';
import {
  Router, NavigationEnd
} from '@angular/router';
import { SharedService } from '../../shared.service';
import {
  Subscription
} from 'rxjs/Subscription';
@Component({
  selector: 'app-front-facing-taxonomies',
  templateUrl: './front-facing-taxonomies.component.html',
})
export class FrontFacingTaxonomiesComponent implements OnInit, OnDestroy {

  taxonomyList = [];
  orgId = '';
  viewType = '';

  startIndex = 0;
  lastIndex = 10;
  minItemPerPage;
  eventSubscription: Subscription;
  currentUrl = null;
  taxonomyLoader = false; // holds loading state for fetching taxonomy list
  
  @ViewChild('sortListRef') sortListRef: SortListComponent;
  isAdvSearchFrontFacing = false;
  searhtext : any;
  // ----------------for Common Data table----------------- //
  listOfColumn = [{
    name: 'Name',
    propName: 'title',
    class: '',
    type: 'link',
    redirect: true,
    loadPage: true
  },
  {
    name: 'Published',
    propName: 'updated_at',
    class: '',
    width: '10%',
    type: 'date',
    dateType: 'amCalendar'
  }
  ];
  optionList = [];

  sortOptions = [{
    'type': 'title',
    'isDate': false,
    'isAsce': true,
    'display': 'Title (A-Z)'
  }, {
    'type': 'title',
    'isDate': false,
    'isAsce': false,
    'display': 'Title (Z-A)'
  }, {
    'type': 'updated_at',
    'isDate': true,
    'isAsce': true,
    'display': 'Published (Asc)'
  }, {
    'type': 'updated_at',
    'isDate': true,
    'isAsce': false,
    'display': 'Published (Desc)'
  }];

  
page: any;
pageSize: any = 25;
dataSetAdvSearchlist: any;
advSearchlist: any;
allSourceData: any[] = [];
sortTitleOrder = 'Published (Desc)'
documentIds : any;
bodyItems: any;
allListValueCount : any;
 

  searchingText; // holds text input to search in list
  filterData = []; // holds result array of search
  filterDataEvent: Subscription;
  /*
  , {
    'type': 'description',
    'isDate': false,
    'isAsce': true,
    'display': 'Description (A-Z)'
  }, {
    'type': 'description',
    'isDate': false,
    'isAsce': false,
    'display': 'Description (Z-A)'
  }, */

  constructor(private service: CommonService, private router: Router, private sharedService: SharedService) {
    this.minItemPerPage = Utils.PAGINATION_LOWER_LIMIT;

    this.router.events.filter(event => event instanceof NavigationEnd).subscribe((event: any) => {
      if (event.url.indexOf('/taxonomies') >= 0) {
        this.currentUrl = 'taxonomy';
      }
    });
    this.eventSubscription = this.sharedService.activeLink.subscribe((events: any) => {
    });

    this.sharedService.searchTextEvent.subscribe((res: any) => {
      this.searchingText = res.text;
    });

    this.filterDataEvent = this.sharedService.filterDataTable.subscribe((res: any) => {
      this.filterData = res.data;
    });
  }

  ngOnInit() {
    this.searchingText = '';
    this.getTaxonomiesList();
    //this.getAdvSearchFrontfacingTaxonomiesList();
    if (document.querySelector('body')) {
      const element = document.querySelector('body');
      element.classList.remove('hide-vScroll');
    }
 
  }

  /* --------- Get taxonomies functionality Started --------- */
  getTaxonomiesList() {
    this.taxonomyList = [];
    this.taxonomyLoader = true;
    if (localStorage.getItem('orgDetails')) {
      this.orgId = JSON.parse(localStorage.getItem('orgDetails'))['orgId'];
    }
    const url = GlobalSettings.FRONT_FACE_TAXONOMY_LIST + '/' + this.orgId;
    if (this.orgId) {
      this.service.getUserServiceDataWithoutTocken(url).then((res: any) => {
        this.taxonomyList = res;
        this.documentIds = this.taxonomyList.map(entry => entry.document_id);
        setTimeout(() => {
          this.sortListRef.sortPublished('Published (Desc)');
        }, 75);
        this.taxonomyLoader = false;
      }).catch((ex) => {
        console.log('getTaxonomiesList Ex', ex);
        this.taxonomyLoader = false;
      });
    }
  }
  /* --------- Get taxonomies functionality Ended --------- */


  changeDateToLocalTimeZone(date) {
    return Utils.changeDateToLocalTimeZone(date);
  }

  changeView(type) {
    this.viewType = type;
  }



  showDataInRange(event) {
    this.startIndex = event.start - 1;
    this.lastIndex = event.last;
  }

  onTaxonomySelected(item) {
    this.sharedService.setTitleEvent.next({
      'type': 'taxonomy',
      'title': item.title,
      'document_id': item.document_id
    });
    const path = this.service.getOrgDetails() + '/' + Utils.ROUTE_FRONT_FACE_TAXONOMY_DETAIL;
    this.router.navigate([path, item.document_id]);
    }

  ngOnDestroy() {
    if (this.eventSubscription) {
      this.eventSubscription.unsubscribe();
    }
  }

  getColumnFilterObj() {
    const obj = {};
    obj['title'] = this.searchingText;
    return obj;
  }
  
  fnAdvSearchFrontFacing(item) {
      this.isAdvSearchFrontFacing= item.advSearchFrontFacing;
      this.searhtext = item.advSearchtext
      this.getAdvSearchFrontfacingTaxonomiesList();
  }

  getAdvSearchFrontfacingTaxonomiesList(): void {
    this.dataSetAdvSearchlist= null;
    this.page=0;
    const url = GlobalSettings.ELASTIC_SEARCH;
    let bodyDocument =   {
      "start": this.page,
      "size": this.pageSize,
      "hasProject": false,
      "index": "cfdocument",
      "search_match": {},
      "org_id": this.orgId,
      "search_filter": [
          { "title" : this.searhtext,
            "course_description": this.searhtext
           },
           {"document_id.keyword": this.documentIds}
      ],
      "response": [],
      "unique_search": {},
      "collapse": "",
      "front_facing": true,
      "organization_id": this.orgId
    };

    this.service.getWithoutTockenAdvSearchFrontfacing(url,bodyDocument).then((documentsResponse: any) => {
          const documentsCount = documentsResponse.data.hits.total.value;
          const documentArrCount = documentsResponse.data.hits ? documentsResponse.data.hits.hits.length :0;
            this.bodyItems = {
              "start": this.page,
              "size": this.pageSize-documentArrCount ,
              "hasProject": false,
              "index": "cfitems",
              "search_match": {},
              "org_id": this.orgId,
              "search_filter": [
                {
                  "fullStatement": this.searhtext,
                  "humanCodingScheme": this.searhtext,
                  "course_description": this.searhtext
                },
                {"document_id.keyword": this.documentIds}
              ],
              "response": [],
              "unique_search": {},
              "collapse": "",
              "front_facing": true,
              "organization_id": this.orgId
            };
            
            this.service.getWithoutTockenAdvSearchFrontfacing(url,this.bodyItems).then((itemsResponse: any) => {
                  this.dataSetAdvSearchlist = documentsResponse.data.hits.hits.concat(itemsResponse.data.hits.hits);
                  this.allListValueCount = documentsCount+(itemsResponse.data.hits.total.value);
                },
                error => {
                  // Handle errors
                }
              );
        },
        error => {
          // Handle errors
        }
      );
  }
  printPreview(){
    var css = `
    .text-center {
      text-align: center !important;
    }
    .data-table-advance {
      font-size: .875em;
      font-family: "Lato", sans-serif;
      color: #000000;
      text-align: left;
      border: 1px solid #cad5d6;
      border-collapse: collapse;
    }
    .data-table-advance th {
      background: #EAEEEE;
    }
    .data-table-advance th,
    .data-table-advance td {      
      border-top: 1px solid #dee2e6;      
      border-bottom: 0;
      font-weight: 400;
      padding: 12px 15px 12px 25px;
      vertical-align: middle;
    }
    .data-table-advance th:nth-child(1),
    .data-table-advance th:nth-child(6) {
      width: 20%;
    }
    .data-table-advance th:nth-child(4) {
      width: 12%;
    }
    .data-table-advance tbody a {
      color: #2e6bc7;
      text-decoration: none;
    }
    title {
      visibility: hidden;
    }
        `;
    const printWindow = window.open('');
    if (printWindow) {
      printWindow.document.write('<html><head><title>Search Result</title>');
      printWindow.document.write('<style>' + css + '</style>');
      printWindow.document.write('</head><body>');
      const contentToPrint = document.querySelector('.table-responsive');
      if (contentToPrint) {
        printWindow.document.write(contentToPrint.innerHTML);
      } else {
        console.error('Content to print not found.');
      }
      printWindow.document.write('</body></html>');
      printWindow.document.close();
      printWindow.print();
    } else {
      console.error('Failed to open print preview window.');
    }
  }
  sortData(order: string) {
    if (order === 'asc') {
      this.sortTitleOrder =  'Published (Asc)'
      this.dataSetAdvSearchlist.sort((a, b) => {
        return new Date(a._source.lastChangeDateTime).getTime() - new Date(b._source.lastChangeDateTime).getTime();
      });
    } else if (order === 'desc') {
      this.sortTitleOrder =  'Published (Desc)'
      this.dataSetAdvSearchlist.sort((a, b) => {
        return new Date(b._source.lastChangeDateTime).getTime() - new Date(a._source.lastChangeDateTime).getTime();
      });
    }
  }
  sortByTitle(order: string) {
    if (order === 'asc') {
      this.sortTitleOrder =  'Title (A-Z)'
      this.dataSetAdvSearchlist.sort((a, b) => {
        const titleA = a._index == 'cfitems' ? (a._source.CFDocumentURI.title).trim()  : a._source.title.trim() ;
        const titleB = b._index == 'cfitems' ? (b._source.CFDocumentURI.title).trim() : b._source.title.trim() ;
        return titleA.localeCompare(titleB);
      });
    } else if (order === 'desc') {
      this.sortTitleOrder =  'Title (Z-A)'
      this.dataSetAdvSearchlist.sort((a, b) => {
        const titleA = a._index == 'cfitems' ? (a._source.CFDocumentURI.title).trim()  : a._source.title.trim() ;
        const titleB = b._index == 'cfitems' ? (b._source.CFDocumentURI.title).trim()  : b._source.title.trim() ;
        return titleB.localeCompare(titleA);
      });
    }
  }
  sortDatalist(dataList){
    this.dataSetAdvSearchlist = dataList;
  }
}
